import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import * as React from "react";
import { maxNameLength } from "src/common/rxName";

import * as styles from "./QuerySearch.module.less";

type PropsQuerySearch = {
  value?: string;
  onChange: (value?: string) => void;
};

export const QuerySearch: React.FC<PropsQuerySearch> = ({
  value,
  onChange,
}) => {
  const [text, setText] = React.useState(value ?? "");
  React.useEffect(() => {
    setText(value ?? "");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };
  const handleClear = () => {
    setText("");
    onChange(undefined);
  };
  const handleSearch = () => {
    onChange(text.trim() ? text : undefined);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  return (
    <Input
      className={styles.search}
      value={text}
      allowClear
      maxLength={maxNameLength}
      placeholder="Поиск"
      count={{ show: true, max: maxNameLength }}
      onClear={handleClear}
      onKeyDown={handleKeyDown}
      addonAfter={
        <button type="button" className={styles.btn} onClick={handleSearch}>
          <SearchOutlined />
          Найти
        </button>
      }
      onChange={handleChange}
    />
  );
};
